<div class="d-flex justify-content-between mb-3">
  <app-coupon-card
    *ngFor="let coupon of couponList"
    [coupon]="coupon"
    [isRedeemed]="isRedeemed"
    [isActive]="selectedCoupon?.id === coupon.id"
    (click)="onSelectCoupon(coupon)"
  ></app-coupon-card>
</div>

<div class="columns-layout" *ngIf="selectedCoupon && !isRedeemed">
  <app-validate-coupon-details [coupon]="selectedCoupon"></app-validate-coupon-details>
</div>

<ngb-alert
  *ngIf="selectedCoupon && isRedeemed"
  class="message-container"
  type="success"
  [dismissible]="false"
  >
  <h4 class="fw-bold">{{ 'features.validateCoupon.validatedMessageTitle' | transloco }}</h4>
  <div class="mb-1">{{ selectedCoupon.name }}</div>
  <p>{{ 'features.validateCoupon.validatedMessage' | transloco }}</p>
</ngb-alert>
